import logo from './odysseylogo.png';

export function Banner() {
    return(
    <div id="banner">
    <img src={logo}/>
        <h1>Organizational Transformation Simulation - <i>Odysseus Healthcare</i></h1>
    </div>
    )
}